/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto } from '../../models/user-dto';

export interface UsersControllerGetUserById$Params {
  userId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function usersControllerGetUserById(
  http: HttpClient,
  rootUrl: string,
  params: UsersControllerGetUserById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, usersControllerGetUserById.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

usersControllerGetUserById.PATH = '/api/v1/users/{userId}';
